import _ from "lodash";
export const initialState = {
  totalData: [],
  search: [],
  searchResults: [],
  isLoading: true,
  isError: false,
  searchQuery: "",
};
const searcher = (payload: string, total: any) => {
  let searchArr: any = [];
  for (let data of total) {
    if (data.title.search(payload) === 0 || data.title.includes(payload)) {
      searchArr.push(data);
    }
  }
  return searchArr;
};
export default function SearchReducer(state: any, action: any) {
  switch (action.type) {
    case "SET_DATA":
      return {
        ...state,
        totalData: action.payload,
      };
    case "SET_SEARCH":
      return {
        ...state,
        search: action.payload,
        isLoading: false,
      };
    case "SET_SEARCH_THAI":
      return {
        ...state,
        searchQuery: action.payload.searchQuery,
        searchResults: searcher(action.payload.searchQuery, state.totalData),
      };
    case "SET_SEARCH_QUERY":
      return {
        ...state,
        searchQuery: action.payload.searchQuery,
        searchResults: action.payload.searchResults,
      };
    default:
      return state;
  }
}
